import React from 'react';
import QuizSettings from '../components/QuizSettings';
import { QuizSettings as QuizSettingsType } from '../types/quiz';
import { Container, Title } from '../styles/StyledComponents';
import styled from 'styled-components';

interface HomePageProps {
  onStartQuiz: (settings: QuizSettingsType) => void;
}

const PageTitle = styled(Title)`
  margin-top: 0;
`;

const HomePage: React.FC<HomePageProps> = ({ onStartQuiz }) => {
  return (
    <Container>
      <PageTitle>Roadtrip Quiz</PageTitle>
      <QuizSettings onStartQuiz={onStartQuiz} />
    </Container>
  );
};

export default HomePage;
